export type Language = "en" | "fr";

export const languages: { value: Language; label: string; native: string; flag: string }[] = [
  { value: "en", label: "English", native: "English", flag: "🇬🇧" },
  { value: "fr", label: "French", native: "Français", flag: "🇫🇷" },
];

/** English → French for every interface string rendered by the dashboard. */
export const fr: Record<string, string> = {
  // Shell & navigation
  "Deuxda Admin": "Deuxda Admin",
  "Marketplace administration": "Administration de la marketplace",
  "Piloting": "Pilotage",
  "Search navigation...": "Rechercher dans le menu...",
  "Search navigation": "Rechercher dans le menu",
  "Search within this view...": "Rechercher dans cette vue...",
  "Search within this view": "Rechercher dans cette vue",
  "Main navigation": "Navigation principale",
  "Open navigation": "Ouvrir la navigation",
  "Collapse navigation": "Réduire la navigation",
  "Expand navigation": "Déployer la navigation",
  "Collapse": "Réduire",
  "Expand": "Déployer",
  "Refresh": "Actualiser",
  "Logout": "Déconnexion",
  "Administrator": "Administrateur",
  "Profile settings": "Paramètres du profil",
  "Profile settings opened": "Paramètres du profil ouverts",
  "Signed out of the demo session": "Déconnecté de la session de démonstration",
  "Switch to dark mode": "Passer en mode sombre",
  "Switch to light mode": "Passer en mode clair",
  "Overview": "Vue d'ensemble",
  "Revenue and priorities": "Revenus et priorités",
  "Shops": "Boutiques",
  "Seller validation": "Validation des vendeurs",
  "Products": "Produits",
  "Catalogue and stock": "Catalogue et stock",
  "Users": "Utilisateurs",
  "Accounts and roles": "Comptes et rôles",
  "Orders": "Commandes",
  "Operational monitoring": "Suivi opérationnel",
  "Payments": "Paiements",
  "Seller transactions": "Transactions des vendeurs",
  "Notice": "Signalements",
  "Moderation workspace": "Espace de modération",
  "Messages": "Messages",
  "Customer conversations": "Conversations clients",
  "Notifications": "Notifications",
  "Push campaigns": "Campagnes push",
  "Customer data": "Données clients",
  "Addresses and sync": "Adresses et synchronisation",
  "Checks": "Vérifications",
  "Seller KYC": "KYC vendeurs",
  "Categories": "Catégories",
  "Hierarchy and prominence": "Hiérarchie et mise en avant",
  "Menus": "Menus",
  "Web, mobile and admin": "Web, mobile et admin",
  "Configuration": "Configuration",
  "Application settings": "Paramètres de l'application",
  "Support": "Support",
  "Tickets and assignments": "Tickets et affectations",
  "Help Center": "Centre d'aide",
  "Guides and articles": "Guides et articles",
  "Mailing": "Emailing",
  "Email campaigns and audiences": "Campagnes e-mail et audiences",
  "Store layout": "Agencement boutique",
  "Subscriptions, badges and seller plans": "Abonnements, badges et forfaits vendeurs",
  "Moderation": "Modération",
  "Products, reviews, messages and KYC": "Produits, avis, messages et KYC",
  "Roles and authorizations": "Rôles et autorisations",
  "Granular access for the team": "Accès granulaire pour l'équipe",
  "Vehicle inspection": "Inspection des véhicules",
  "Maintenance, purchases and withdrawals": "Entretien, achats et retraits",
  "Settings": "Paramètres",
  "Preferences and language": "Préférences et langue",

  // Settings screen
  "Adjust the language, appearance and regional preferences of the console.":
    "Ajustez la langue, l'apparence et les préférences régionales de la console.",
  "Language": "Langue",
  "Choose the language used across the whole admin console.":
    "Choisissez la langue utilisée dans toute la console d'administration.",
  "Interface language": "Langue de l'interface",
  "Appearance": "Apparence",
  "Light": "Clair",
  "Dark": "Sombre",
  "Theme": "Thème",
  "Use the carefully balanced dark interface.": "Utiliser l'interface sombre soigneusement équilibrée.",
  "Dark mode": "Mode sombre",
  "Compact tables": "Tableaux compacts",
  "Reduce row height for dense data screens.": "Réduire la hauteur des lignes sur les écrans denses.",
  "Regional preferences": "Préférences régionales",
  "Region and formats used for dates, numbers and currency.":
    "Région et formats utilisés pour les dates, les nombres et la devise.",
  "Notifications and alerts": "Notifications et alertes",
  "Choose what the console notifies you about.": "Choisissez ce dont la console vous informe.",
  "Email digests": "Résumés par e-mail",
  "A daily summary of marketplace activity.": "Un résumé quotidien de l'activité de la marketplace.",
  "Critical alerts": "Alertes critiques",
  "Payment failures, outages and moderation escalations.":
    "Échecs de paiement, pannes et escalades de modération.",
  "Product updates": "Nouveautés produit",
  "Occasional messages about new Deuxda features.":
    "Messages occasionnels sur les nouvelles fonctionnalités Deuxda.",
  "Settings saved": "Paramètres enregistrés",
  "Language updated": "Langue mise à jour",
  "Save preferences": "Enregistrer les préférences",
  "Reset to defaults": "Réinitialiser",
  "Preferences reset": "Préférences réinitialisées",

  // Generic actions & table chrome
  "Actions": "Actions",
  "Save": "Enregistrer",
  "Save changes": "Enregistrer les modifications",
  "Cancel": "Annuler",
  "Clear": "Effacer",
  "Delete": "Supprimer",
  "DELETE": "SUPPRIMER",
  "Edit": "Modifier",
  "Modify": "Modifier",
  "To modify": "Modifier",
  "To update": "Mettre à jour",
  "Update": "Mettre à jour",
  "Add": "Ajouter",
  "Assign": "Attribuer",
  "Approve": "Approuver",
  "Reject": "Rejeter",
  "Remove": "Retirer",
  "Suspend": "Suspendre",
  "Preview": "Aperçu",
  "Details": "Détails",
  "View details": "Voir les détails",
  "Download": "Télécharger",
  "Download report": "Télécharger le rapport",
  "Download document": "Télécharger le document",
  "Export CSV": "Exporter en CSV",
  "Import CSV": "Importer un CSV",
  "Import & export": "Import et export",
  "Search": "Rechercher",
  "Filters": "Filtres",
  "Status": "Statut",
  "Type": "Type",
  "Name": "Nom",
  "Title": "Titre",
  "Description": "Description",
  "Date": "Date",
  "Amount": "Montant",
  "Total": "Total",
  "Notes": "Notes",
  "Comment": "Commentaire",
  "Content": "Contenu",
  "Category": "Catégorie",
  "Slug": "Slug",
  "Price": "Prix",
  "Stock": "Stock",
  "Owner": "Propriétaire",
  "Shop": "Boutique",
  "Product": "Produit",
  "Order": "Commande",
  "Customer": "Client",
  "Customers": "Clients",
  "Seller": "Vendeur",
  "Buyer": "Acheteur",
  "Admin": "Admin",
  "Superadmin": "Super-admin",
  "Super Admin": "Super Admin",
  "Moderator": "Modérateur",
  "Operations": "Opérations",
  "Finance": "Finance",
  "User": "Utilisateur",
  "Role": "Rôle",
  "Permissions": "Autorisations",
  "Members": "Membres",
  "Team": "Équipe",
  "Team members": "Membres de l'équipe",
  "Agent": "Agent",
  "Agents": "Agents",
  "Priority": "Priorité",
  "Subject": "Sujet",
  "Message": "Message",
  "Response": "Réponse",
  "Rows per page": "Lignes par page",
  "Cards per page": "Cartes par page",
  "Next page": "Page suivante",
  "Previous page": "Page précédente",
  "No records found": "Aucun enregistrement trouvé",
  "No data available": "Aucune donnée disponible",
  "Try changing your search or filters.": "Essayez de modifier votre recherche ou vos filtres.",
  "Select all visible rows": "Sélectionner toutes les lignes visibles",
  "This action cannot be undone.": "Cette action est irréversible.",
  "Confirm action": "Confirmer l'action",
  "Data loaded successfully": "Données chargées avec succès",
  "CSV export ready": "Export CSV prêt",
  "Preparing filtered CSV…": "Préparation du CSV filtré…",
  "Bulk update complete": "Mise à jour groupée terminée",
  "Records synced": "Enregistrements synchronisés",
  "All": "Tous",
  "Active": "Actif",
  "Assets": "Actifs",
  "Inactive": "Inactif",
  "Pending": "En attente",
  "On hold": "En attente",
  "Approved": "Approuvé",
  "Rejected": "Rejeté",
  "Suspended": "Suspendu",
  "Expired": "Expiré",
  "Draft": "Brouillon",
  "Published": "Publié",
  "Open": "Ouvert",
  "Opened": "Ouvert",
  "Resolved": "Résolu",
  "Escalated": "Escaladé",
  "In progress": "En cours",
  "In review": "En révision",
  "Review": "À vérifier",
  "Processing": "En traitement",
  "Completed": "Terminé",
  "Cancelled": "Annulé",
  "Delivered": "Livré",
  "Delivery": "Livraison",
  "Failed": "Échoué",
  "Paid": "Payé",
  "Refunded": "Remboursé",
  "Stranded": "Bloqué",
  "Scheduled": "Planifié",
  "Sent": "Envoyé",
  "Unassigned": "Non attribué",
  "Not assigned": "Non attribué",
  "Not routed": "Non orienté",
  "Assigned: Not assigned": "Attribué : non attribué",
  "Locked": "Verrouillé",
  "Verified": "Vérifié",
  "Healthy": "Sain",
  "Unknown": "Inconnu",
  "High": "Haute",
  "Medium": "Moyenne",
  "Low": "Basse",
  "Normal": "Normale",
  "Urgent": "Urgente",
  "Low stock": "Stock faible",
  "In stock": "En stock",
  "Out of stock": "Rupture de stock",
  "This month": "Ce mois-ci",
  "Today": "Aujourd'hui",
  "General": "Général",
  "Global": "Global",
  "Legal": "Juridique",
  "Platform": "Plateforme",
  "Marketplace": "Marketplace",
  "Featured": "Mis en avant",
  "Highlight": "Mettre en avant",
  "Form": "Formulaire",
  "JSON code": "Code JSON",
  "Expiry": "Expiration",
  "Renews": "Renouvellement",
  "Plan": "Forfait",
  "Badge": "Badge",
  "Commission": "Commission",
  "Created": "Créé le",
  "Created Date": "Date de création",
  "Updated Date": "Date de mise à jour",
  "Submitted Date": "Date de soumission",
  "Latest Activity": "Dernière activité",
  "Latest activity": "Dernière activité",
  "Empower": "Renforcer",
  "E-mail": "E-mail",
  "Phone": "Téléphone",
  "City": "Ville",
  "District": "District",
  "Scope": "Périmètre",
  "Audience": "Audience",
  "Campaign": "Campagne",
  "Views": "Vues",
  "Errors": "Erreurs",
  "Cost": "Coût",
  "Target": "Objectif",
  "Version": "Version",
  "Timezone": "Fuseau horaire",
  "Locale": "Région",
  "Date format": "Format de date",
  "Default currency": "Devise par défaut",
  "Regional settings": "Paramètres régionaux",
  "App name": "Nom de l'application",
  "App settings": "Paramètres de l'app",
  "Social links": "Réseaux sociaux",
  "API credentials": "Identifiants API",
  "Publishable key": "Clé publiable",
  "Show credential": "Afficher la clé",
  "Hide credential": "Masquer la clé",
  "Copy credential": "Copier la clé",
  "Credential copied": "Clé copiée",
  "Regenerate key": "Régénérer la clé",
  "New publishable key generated": "Nouvelle clé publiable générée",
  "Maintenance mode": "Mode maintenance",
  "Temporarily pause customer access.": "Suspendre temporairement l'accès des clients.",
  "Configuration saved": "Configuration enregistrée",
  "Sync status": "État de synchronisation",
  "Last sync": "Dernière synchronisation",
  "All systems operational": "Tous les systèmes sont opérationnels",
  "System": "Système",
  "System Operations": "Opérations système",
  "System scan": "Analyse du système",

  // Overview
  "Growth, revenue and operations in real time": "Croissance, revenus et opérations en temps réel",
  "Deuxda marketplace growth, revenue and operational priorities.":
    "Croissance, revenus et priorités opérationnelles de la marketplace Deuxda.",
  "Total shops": "Boutiques totales",
  "Active users": "Utilisateurs actifs",
  "Total orders": "Commandes totales",
  "Total paid": "Total payé",
  "New users": "Nouveaux utilisateurs",
  "New customers": "Nouveaux clients",
  "User growth": "Croissance des utilisateurs",
  "Daily activity": "Activité quotidienne",
  "New accounts per month in 2026": "Nouveaux comptes par mois en 2026",
  "Orders placed within the last 14 days": "Commandes passées ces 14 derniers jours",
  "Deuxda Ecosystem": "Écosystème Deuxda",
  "Ecosystem data will appear after the next synchronization.":
    "Les données de l'écosystème apparaîtront après la prochaine synchronisation.",
  "Operational priorities": "Priorités opérationnelles",
  "Open the relevant queue": "Ouvrir la file concernée",
  "Approve catalogue items": "Approuver les articles du catalogue",
  "Review seller documents": "Vérifier les documents vendeurs",
  "Resolve policy issues": "Résoudre les problèmes de conformité",
  "Products to validate": "Produits à valider",
  "Pending sellers": "Vendeurs en attente",
  "Open cases": "Dossiers ouverts",
  "Open tickets": "Tickets ouverts",
  "Shops on hold": "Boutiques en attente",
  "Active sellers": "Vendeurs actifs",
  "Verified sellers": "Vendeurs vérifiés",
  "Orders of the month": "Commandes du mois",
  "Marketplace monthly": "Mensuel marketplace",
  "Cumulative flow": "Flux cumulé",
  "Breakdown of the main active volumes.": "Répartition des principaux volumes actifs.",

  // Screen headers & descriptions
  "Validate sellers and monitor marketplace storefronts.":
    "Validez les vendeurs et surveillez les vitrines de la marketplace.",
  "Review catalogue quality, approvals and inventory.":
    "Contrôlez la qualité du catalogue, les approbations et les stocks.",
  "Click on an account to open its full operational profile.":
    "Cliquez sur un compte pour ouvrir son profil opérationnel complet.",
  "Monitor fulfilment and resolve operational exceptions.":
    "Suivez l'exécution des commandes et traitez les exceptions.",
  "Track seller payouts and transaction exceptions.":
    "Suivez les versements aux vendeurs et les anomalies de transaction.",
  "Review reported content and record moderation decisions.":
    "Examinez les contenus signalés et enregistrez les décisions de modération.",
  "Manage conversations with customers, sellers and operations.":
    "Gérez les conversations avec les clients, les vendeurs et les équipes.",
  "Manage customer and seller conversations.": "Gérez les conversations clients et vendeurs.",
  "Build, schedule and measure push notification campaigns.":
    "Créez, planifiez et mesurez les campagnes de notifications push.",
  "Manage synchronized customer records and delivery addresses.":
    "Gérez les fiches clients synchronisées et les adresses de livraison.",
  "Review seller identity and business verification documents.":
    "Vérifiez les documents d'identité et d'entreprise des vendeurs.",
  "Manage the Deuxda marketplace category hierarchy.":
    "Gérez la hiérarchie des catégories de la marketplace Deuxda.",
  "Build navigation menus for Deuxda platforms.": "Créez les menus de navigation des plateformes Deuxda.",
  "Build navigation for each Deuxda platform.": "Créez la navigation de chaque plateforme Deuxda.",
  "Manage Deuxda application and regional settings.":
    "Gérez les paramètres applicatifs et régionaux de Deuxda.",
  "Manage Deuxda branding, regional settings and platform controls.":
    "Gérez l'identité Deuxda, les paramètres régionaux et les contrôles de la plateforme.",
  "Resolve customer and seller requests efficiently.":
    "Traitez efficacement les demandes des clients et des vendeurs.",
  "Publish and maintain customer support documentation.":
    "Publiez et maintenez la documentation d'assistance client.",
  "Manage the customer-facing Help Center content.": "Gérez le contenu du centre d'aide destiné aux clients.",
  "Create targeted email campaigns and measure delivery.":
    "Créez des campagnes e-mail ciblées et mesurez la délivrabilité.",
  "Subscriptions, badges and seller plans for marketplace storefronts.":
    "Abonnements, badges et forfaits vendeurs pour les vitrines de la marketplace.",
  "Review products, reviews, messages and KYC in one queue.":
    "Examinez produits, avis, messages et KYC dans une seule file.",
  "Granular access control for the Deuxda team.": "Contrôle d'accès granulaire pour l'équipe Deuxda.",
  "Fleet maintenance, purchases and withdrawals for Deuxda logistics.":
    "Entretien de la flotte, achats et retraits pour la logistique Deuxda.",

  // Search placeholders
  "Search shops or owners...": "Rechercher une boutique ou un propriétaire...",
  "Search products or shops...": "Rechercher un produit ou une boutique...",
  "Search name or email...": "Rechercher un nom ou un e-mail...",
  "Search order, customer or shop...": "Rechercher une commande, un client ou une boutique...",
  "Search transaction or seller...": "Rechercher une transaction ou un vendeur...",
  "Search by reference, order, shop...": "Rechercher par référence, commande, boutique...",
  "Search reports or content...": "Rechercher un signalement ou un contenu...",
  "Search reports or users...": "Rechercher un signalement ou un utilisateur...",
  "Search conversations...": "Rechercher une conversation...",
  "Search conversations": "Rechercher une conversation",
  "Search customers or locations...": "Rechercher un client ou une localité...",
  "Search campaigns...": "Rechercher une campagne...",
  "Search requests...": "Rechercher une demande...",
  "Search articles...": "Rechercher un article...",
  "Search roles or members...": "Rechercher un rôle ou un membre...",
  "Search plans or sellers...": "Rechercher un forfait ou un vendeur...",
  "Search seller or shop...": "Rechercher un vendeur ou une boutique...",
  "Search by shop name...": "Rechercher par nom de boutique...",
  "Search for a category...": "Rechercher une catégorie...",
  "Search ticket, customer or subject...": "Rechercher un ticket, un client ou un sujet...",
  "Search vehicles or entries...": "Rechercher un véhicule ou une entrée...",
  "Search support requests": "Rechercher une demande d'assistance",
  "Search subscriptions": "Rechercher un abonnement",
  "Search shop": "Rechercher une boutique",

  // Row actions
  "Add shop": "Ajouter une boutique",
  "Add product": "Ajouter un produit",
  "Add role": "Ajouter un rôle",
  "Add plan": "Ajouter un forfait",
  "Add menu item": "Ajouter un élément de menu",
  "Manage stock": "Gérer le stock",
  "View profile": "Voir le profil",
  "View shop": "Voir la boutique",
  "View customer": "Voir le client",
  "Change role": "Changer de rôle",
  "Change status": "Changer le statut",
  "Change priority": "Changer la priorité",
  "Update status": "Mettre à jour le statut",
  "Transaction details": "Détails de la transaction",
  "Review comments": "Examiner les commentaires",
  "Record decision": "Enregistrer la décision",
  "Request resubmission": "Demander une nouvelle soumission",
  "Open ticket": "Ouvrir le ticket",
  "Edit article": "Modifier l'article",
  "Edit template": "Modifier le modèle",
  "Edit address": "Modifier l'adresse",
  "Remove address": "Supprimer l'adresse",
  "Publish / unpublish": "Publier / dépublier",
  "Preview campaign": "Aperçu de la campagne",
  "Preview document": "Aperçu du document",
  "Campaign analytics": "Statistiques de campagne",
  "Duplicate campaign": "Dupliquer la campagne",
  "Review the complete record and recent activity.":
    "Consultez la fiche complète et l'activité récente.",
  "A rejection reason is required and will be shared with the seller.":
    "Un motif de rejet est requis et sera communiqué au vendeur.",
  "Validation report downloaded": "Rapport de validation téléchargé",
  "CSV file selected for validation": "Fichier CSV sélectionné pour validation",
  "Upload customer CSV": "Importer le CSV clients",
  "Validated before any records are changed": "Validé avant toute modification des fiches",
  "Latest import": "Dernier import",
  "Synchronize customer address records using CSV files.":
    "Synchronisez les adresses clients à l'aide de fichiers CSV.",

  // Payments
  "Total amount paid": "Montant total payé",
  "Pending payments": "Paiements en attente",
  "Volume refunded": "Volume remboursé",
  "Withdrawals paid": "Retraits payés",
  "Withdrawals in progress": "Retraits en cours",
  "Buyer fees": "Frais acheteurs",
  "Seller's fees": "Frais vendeurs",
  "Payment channels": "Canaux de paiement",
  "Payment flows": "Flux de paiement",
  "Payment Method": "Moyen de paiement",
  "Refund requests": "Demandes de remboursement",
  "Merchant withdrawals": "Retraits marchands",
  "Mobile money": "Mobile money",
  "Bank Card": "Carte bancaire",
  "Bank transfer": "Virement bancaire",
  "Manual / Species": "Manuel / Espèces",
  "New Transaction": "Nouvelle transaction",
  "New transaction form opened": "Formulaire de nouvelle transaction ouvert",
  "Transactions": "Transactions",
  "No transactions match your search.": "Aucune transaction ne correspond à votre recherche.",
  "List of financial flows associated with customer orders.":
    "Liste des flux financiers associés aux commandes clients.",
  "Distribution of settlement volumes by payment method":
    "Répartition des volumes de règlement par moyen de paiement",
  "Merchant payouts made": "Versements marchands effectués",
  "How seller payouts work": "Fonctionnement des versements vendeurs",
  "Payout has not arrived": "Le versement n'est pas arrivé",
  "Withdrawal": "Retrait",
  "Purchase": "Achat",
  "Spend this month": "Dépenses ce mois-ci",
  "Monthly recurring": "Récurrent mensuel",

  // Users
  "All users": "Tous les utilisateurs",
  "No users in this group.": "Aucun utilisateur dans ce groupe.",
  "Unnamed user": "Utilisateur sans nom",

  // Support
  "Support desk": "Bureau d'assistance",
  "Inbox": "Boîte de réception",
  "Conversation": "Conversation",
  "Conversation actions": "Actions de conversation",
  "Send CSAT": "Envoyer le CSAT",
  "CSAT survey sent": "Enquête CSAT envoyée",
  "Customer care": "Service client",
  "Avg. response": "Réponse moyenne",
  "Responding to the customer...": "Répondre au client...",
  "Answer": "Répondre",
  "Answer sent": "Réponse envoyée",
  "Reply sent": "Réponse envoyée",
  "Send reply": "Envoyer la réponse",
  "Write a reply": "Écrire une réponse",
  "Write a reply...": "Écrire une réponse...",
  "Write your message...": "Écrivez votre message...",
  "Images and documents up to 50 MB.": "Images et documents jusqu'à 50 Mo.",
  "Attach a file": "Joindre un fichier",
  "Attach media": "Joindre un média",
  "Add optional media": "Ajouter un média (facultatif)",
  "Add optional context...": "Ajouter un contexte (facultatif)...",
  "Choose an attachment": "Choisir une pièce jointe",
  "Internal note": "Note interne",
  "Optional details": "Détails facultatifs",
  "Ticket support": "Support tickets",
  "Case ID": "N° de dossier",
  "Assigned To": "Attribué à",
  "Delivery problem": "Problème de livraison",
  "Refund for my order": "Remboursement de ma commande",
  "Incorrect delivery address": "Adresse de livraison incorrecte",
  "Promo code issue": "Problème de code promo",
  "Unable to complete payment": "Impossible de finaliser le paiement",
  "Return request": "Demande de retour",
  "Returns and refunds": "Retours et remboursements",
  "Product review": "Avis produit",
  "Reported User": "Utilisateur signalé",
  "Reporter": "Auteur du signalement",
  "Resolved today": "Résolus aujourd'hui",
  "Approved today": "Approuvés aujourd'hui",
  "Awaiting review": "En attente d'examen",
  "Resubmission": "Nouvelle soumission",
  "Resubmissions": "Nouvelles soumissions",
  "Documents requested": "Documents demandés",
  "Preparing KYC documents": "Préparation des documents KYC",
  "KYC checks": "Vérifications KYC",
  "KYC document": "Document KYC",
  "Document Type": "Type de document",
  "National ID": "Carte d'identité",
  "Business licence": "Licence commerciale",
  "TIN certificate": "Attestation fiscale",

  // Help center
  "Add an article": "Ajouter un article",
  "Article title": "Titre de l'article",
  "Article added": "Article ajouté",
  "Article updated": "Article mis à jour",
  "Article deleted": "Article supprimé",
  "Create article": "Créer un article",
  "Delete article": "Supprimer l'article",
  "Delete this article?": "Supprimer cet article ?",
  "Modify article": "Modifier l'article",
  "Edit the element": "Modifier l'élément",
  "Back to the list": "Retour à la liste",
  "JSON metadata": "Métadonnées JSON",
  "Optional article metadata": "Métadonnées facultatives de l'article",
  "Add a key-value pair": "Ajouter une paire clé-valeur",
  "Metadata field added": "Champ de métadonnées ajouté",
  "Highlight article": "Mettre l'article en avant",
  "Short customer-facing description": "Courte description destinée aux clients",
  "No description available.": "Aucune description disponible.",
  "FAQ articles, customer guides and content used by the help page.":
    "Articles FAQ, guides clients et contenus utilisés par la page d'aide.",
  "Privacy Policy": "Politique de confidentialité",
  "Terms of Use": "Conditions d'utilisation",
  "Legal notice": "Mentions légales",
  "Refunds and disputes": "Remboursements et litiges",
  "Who are we?": "Qui sommes-nous ?",
  "Our mission": "Notre mission",
  "Discover how Deuxda collects, uses and protects your personal data.":
    "Découvrez comment Deuxda collecte, utilise et protège vos données personnelles.",

  // Categories
  "Dynamic catalog": "Catalogue dynamique",
  "Publication categories and fields": "Catégories et champs de publication",
  "Publication fields": "Champs de publication",
  "Publication Fields & Attributes": "Champs et attributs de publication",
  "Hierarchy & Tree Structure": "Hiérarchie et arborescence",
  "Active tree structure": "Arborescence active",
  "New Category": "Nouvelle catégorie",
  "New category form opened": "Formulaire de nouvelle catégorie ouvert",
  "Subcategory": "Sous-catégorie",
  "Children": "Sous-catégories",
  "Fields": "Champs",
  "Avatars": "Avatars",
  "With avatar": "Avec avatar",
  "No avatar": "Sans avatar",
  "Display name": "Nom affiché",
  "Edit this category’s publication settings and product fields.":
    "Modifiez les paramètres de publication et les champs produits de cette catégorie.",
  "Reusable attributes for seller forms": "Attributs réutilisables pour les formulaires vendeurs",
  "Decorations": "Décorations",
  "Interior decoration": "Décoration intérieure",
  "Exterior decoration": "Décoration extérieure",
  "Paintings": "Peintures",
  "Executives": "Bureaux",
  "Mirrors": "Miroirs",
  "Wall clocks": "Horloges murales",
  "Vases": "Vases",
  "Electronics": "Électronique",
  "Home & living": "Maison et décoration",
  "Fashion": "Mode",
  "Furniture": "Mobilier",
  "Kitchen": "Cuisine",
  "Computers": "Ordinateurs",
  "Phones & tablets": "Téléphones et tablettes",
  "Men": "Homme",
  "Women": "Femme",
  "Offers": "Offres",

  // Store layout
  "Subscription plans": "Forfaits d'abonnement",
  "Active subscriptions": "Abonnements actifs",
  "Shop badges": "Badges boutique",
  "Sales tiers": "Paliers de ventes",
  "Plan Management": "Gestion des forfaits",
  "Define Deuxda's premium plans for sellers.": "Définissez les forfaits premium Deuxda pour les vendeurs.",
  "Add a subscription plan": "Ajouter un forfait d'abonnement",
  "Define a new commercial offer for merchants.": "Définissez une nouvelle offre commerciale pour les marchands.",
  "New Plan": "Nouveau forfait",
  "New subscription plan": "Nouveau forfait d'abonnement",
  "Assign a plan": "Attribuer un forfait",
  "No subscriptions match the criteria.": "Aucun abonnement ne correspond aux critères.",
  "Badges available": "Badges disponibles",
  "Badges assigned to shops": "Badges attribués aux boutiques",
  "Add a badge": "Ajouter un badge",
  "Assign a badge": "Attribuer un badge",
  "Badge deleted": "Badge supprimé",
  "No badges assigned.": "Aucun badge attribué.",
  "Blue Badge": "Badge bleu",
  "Custom colour shop badges, visible on the website.":
    "Badges boutique aux couleurs personnalisées, visibles sur le site.",
  "History of badge allocation to merchants.": "Historique d'attribution des badges aux marchands.",
  "Automated sales levels": "Paliers de ventes automatisés",
  "Store layout updated": "Agencement boutique mis à jour",
  "Store layout sections": "Sections de l'agencement boutique",
  "Enter a clear name": "Saisissez un nom clair",
  "Enter a name": "Saisissez un nom",
  "Enter the details below to update the seller storefront.":
    "Renseignez les informations ci-dessous pour mettre à jour la vitrine du vendeur.",
  "Active plans": "Forfaits actifs",
  "Across all plans": "Tous forfaits confondus",
  "Expiring soon": "Expire bientôt",
  "Verified seller badge": "Badge vendeur vérifié",
  "Featured badge": "Badge mis en avant",
  "Top seller subscription": "Abonnement meilleur vendeur",
  "Seller setup": "Configuration vendeur",

  // Roles
  "Administrative team": "Équipe administrative",
  "Select an account.": "Sélectionnez un compte.",
  "Each administrator only sees the spaces necessary for their work.":
    "Chaque administrateur ne voit que les espaces nécessaires à son travail.",
  "Custom roles": "Rôles personnalisés",
  "Pending invites": "Invitations en attente",
  "All modules": "Tous les modules",
  "Across 5 roles": "Sur 5 rôles",

  // Notifications & mailing
  "Create campaign": "Créer une campagne",
  "Create notification": "Créer une notification",
  "Notification title": "Titre de la notification",
  "Compose, target and schedule this message.": "Rédigez, ciblez et planifiez ce message.",
  "Schedule": "Planifier",
  "Push": "Push",
  "Push + Email": "Push + e-mail",
  "Emails sent": "E-mails envoyés",
  "Abandoned carts": "Paniers abandonnés",
  "Cart reminder": "Rappel de panier",
  "All customers": "Tous les clients",
  "Notification": "Notification",
  "Welcome to Deuxda": "Bienvenue sur Deuxda",
  "New opportunities on Deuxda": "De nouvelles opportunités sur Deuxda",
  "Tracking your Deuxda order": "Suivi de votre commande Deuxda",
  "Seller verification reminder": "Rappel de vérification vendeur",
  "Daily delivery summary is available.": "Le résumé quotidien des livraisons est disponible.",

  // Menus & configuration
  "Menu item added": "Élément de menu ajouté",
  "Homepage placement": "Emplacement sur la page d'accueil",
  "Shop listing": "Liste des boutiques",
  "Mobile": "Mobile",
  "Log entry": "Entrée de journal",
  "Entry ID": "ID de l'entrée",
  "Content Type": "Type de contenu",
  "Product ID": "ID produit",
  "Shop ID": "ID boutique",
  "Order ID": "N° de commande",
  "Shop Name": "Nom de la boutique",
  "Product image": "Image du produit",
  "Notice & moderation": "Signalements et modération",
  "Maintenance": "Entretien",
  "Maintenance due": "Entretien à prévoir",
  "Maintenance window": "Fenêtre de maintenance",
  "Fleet size": "Taille de la flotte",
  "Vehicle": "Véhicule",
  "Pulled from fleet for inspection": "Retiré de la flotte pour inspection",
  "Oil and filter change": "Vidange et changement de filtre",
  "New tyres (set of 4)": "Pneus neufs (jeu de 4)",
  "Under budget": "Sous le budget",
  "Support language": "Langue du support",
  "English": "Anglais",
  "French": "Français",
  "Français": "Français",
};

const reverse: Record<string, string> = {};
for (const [en, value] of Object.entries(fr)) if (!(value in reverse)) reverse[value] = en;

export function translate(text: string, language: Language): string | null {
  const key = text.trim();
  if (!key) return null;
  const table = language === "fr" ? fr : reverse;
  const hit = table[key];
  if (!hit || hit === key) return null;
  return text.replace(key, hit);
}
